import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    border: "solid darkgray 1px",
    borderRadius: 5,
    display: "flex",
    flexDirection: "row",
    width: "fit-content",
    cursor: "pointer",
    overflow: "hidden",
  },
  option: {
    padding: theme.spacing(1),
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#eeeeee",
    },
  },
  selected: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.getContrastText(theme.palette.primary.light),
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.getContrastText(theme.palette.primary.main),
    },
  },
}));

const Toggle = ({ options, selected, onSelect }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {options.map((o) => (
        <div
          key={o}
          onClick={() => onSelect(o)}
          className={clsx(classes.option, o === selected && classes.selected)}
        >
          {o}
        </div>
      ))}
    </div>
  );
};

Toggle.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default Toggle;
